<template>
  <div class="inbox-wrap">
    <div class="inbox-left">
      <div class="inbox-left-top">
        <connectAccount :referer="'message'" @error-message-check="handleConnectAccountError" />
        <span class="inbox-newmessage pointer" @click="loadInbox(refresh = true)">
          <font-awesome-icon :icon="['far', 'redo-alt']" />
        </span>
      </div>
      <div class="inbox-loading" v-loading="inbox_loading" v-if="inbox_loading"></div>
      <div class="inbox-thread-list scrollbar-a" v-else-if="threads != ''" id="thread-top">
        <div style="width: 100%" v-for="(thread, thread_index) in threads" :key="thread.thread_id" @click="thread_select == thread_index ? '' : openThread(thread.thread_id, thread_index)">
          <div class="inbox-thread" :class="thread_select == thread_index ? 'select' : ''" v-if="thread.users[0]">
            <div class="inbox-thread-imagearea">
              <el-image :src="s3BaseUrl + '/profile_picture/' + thread.users[0].username + '.jpg'" class="inbox-profile">
                <div slot="error" class="data-table-profile-noimg">
                  NO
                  <br />IMAGE
                </div>
              </el-image>
              <div class="inbox-online"></div>
            </div>
            <div class="inbox-thread-titlearea">
              <div class="inbox-thread-username" :class="thread.read_state > 0 ? 'inbox-thread-name-unseen' : ''">
                {{ thread.users[0].username }}・{{ thread.users[0].full_name }}
                <div class="i-detail-similar-listin" v-if="thread.list_in" style="margin-right:10px">
                  <el-tooltip placement="bottom-start">
                    <div slot="content" class="data-table-th-listname-list">
                      <span v-for="list_in in thread.list_in" :key="list_in.list_id" style="margin-right:5px" @click="openList(list_in.list_id)" class="pointer">
                        <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
                        {{ list_in.list_name }}
                        <br /> </span
                      >に追加されています
                    </div>
                    <span>
                      <font-awesome-icon :icon="['fal', 'folder-open']" style="font-size:10px" />
                      {{ thread.list_in.length }}
                    </span>
                  </el-tooltip>
                </div>
              </div>
              <div class="inbox-thread-activity">
                <div class="inbox-thread-name-ellipsis">
                  <span v-if="thread.last_permanent_item" :class="thread.read_state > 0 ? 'inbox-thread-name-unseen' : ''">
                    {{
                        thread.last_permanent_item.item_type == "text"
                        ? thread.last_permanent_item.text
                        : thread.last_permanent_item.item_type == "link"
                        ? thread.last_permanent_item.link.text
                        : thread.last_permanent_item.item_type == "media"
                        ? "写真を送信しました"
                        : thread.last_permanent_item.item_type == "media_share"
                        ? "投稿を送信しました"
                        : thread.last_permanent_item.item_type == "action_log"
                        ? thread.last_permanent_item.action_log.description
                        : thread.last_permanent_item.item_type == "animated_media"
                        ? "スタンプを送信しました"
                        : thread.last_permanent_item.reel_share
                        ? thread.last_permanent_item.reel_share.type == "reaction"
                          ? "ストーリーズにリアクションしました"
                          : thread.last_permanent_item.reel_share.type == "reply"
                          ? "ストーリーズに返信しました"
                          : ""
                        : ""
                    }}
                  </span>
                  <span v-else></span>
                </div>
                <div>・{{ thread.last_activity_at | lastActivity }}</div>
              </div>
            </div>
            <div class="inbox-thread-unseen" v-if="thread.read_state > 0"></div>
            <div class="inbox-thread-label" v-if="thread.thread_label == 1"></div>
          </div>
        </div>
        <div class="inbox-next-cursor" v-if="!inbox_loading && inbox_cursor != ''" @click="InboxCursor()" v-loading="inbox_cursor_loading">
          <font-awesome-icon :icon="['far', 'redo-alt']" />
        </div>
        <div v-else style="min-height:10px"></div>
      </div>
      <div class="inbox-thread-list" v-else-if="connecting_error">
        <div class="inbox-thread-error">
          <div class="inbox-thread-error-icon">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
          </div>
          Instagramとの連携が解除されています。 <br />再度連携を行ってください。
        </div>
      </div>
      <div class="inbox-thread-list" v-else-if="network_error">
        <div class="inbox-thread-error">
          <div class="inbox-thread-error-icon">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
          </div>
          {{ network_error_message }}
        </div>
      </div>
      <div class="inbox-thread-list" v-else-if="ig_info == ''">
        <div class="inbox-thread-error">
          <div class="inbox-thread-warning-icon">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
          </div>
          Instagramアカウントが連携されていません。 <br />メッセージの送受信を行うには連携を行ってください。
        </div>
      </div>
      <div class="inbox-thread-list" v-else-if="ig_info != '' && ig_selected == ''">
        <div class="inbox-thread-error">
          <div class="inbox-thread-warning-icon">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
          </div>
          アカウントが選択されていません。
        </div>
      </div>
    </div>
    <!-- メッセージ -->
    <inboxDetail :thread_id="thread_id" referer="message" @toConnectSetting="toConnectSetting" @loadInbox="loadInbox" @labelThread="labelThread" :ig_id="ig_id" />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const inboxAPI = root + "/api/message/inbox";
const getPresenceAPI = root + "/api/message/get_presence";
import inboxDetail from "./inbox_detail.vue";
import connectAccount from "./connect_account.vue";
import {
  getMessageErrorText,
  getLoginRequiredErrorText,
  isLoginRequiredError,
  isNetworkError,
  isExternalApiErrorEnvelope,
} from "../../utils/messageError";

export default {
  name: "inbox",
  components: {
    inboxDetail,
    connectAccount,
  },
  data() {
    return {
      activeName: "inbox",
      inbox_data: [],
      inbox_cursor: "",
      inbox_cursor_loading: false,
      inbox_loading: false,
      threads: [],
      thread_id: "",
      thread_select: -1,
      ig_id: 0,
      connecting_error: false,
      network_error: false,
      network_error_message: "",
      requestId: 0,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.message.access;
    },
    textarea_rows() {
      var num = this.chat_value.split("\n").length;
      return num > 8 ? 9 : num > 1 ? num : 1;
    },
    textarea_height() {
      return this.textarea_rows * 16;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    sessionid() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.sessionid;
      } else {
        return null;
      }
    },
    csrftoken() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.csrftoken;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.loadInbox();
  },
  methods: {
    loadInbox(refresh) {
      // 連携解除済みアカウントは API を待たず再連携案内を出す
      if (this.ig_selected && this.ig_selected.login_required) {
        this.inbox_loading = false;
        this.inbox_data = [];
        this.threads = [];
        this.connecting_error = true;
        this.network_error = false;
        this.network_error_message = "";
        this.thread_select = -1;
        this.thread_id = "";
        this.$message.closeAll();
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: getLoginRequiredErrorText({
            error_type: "login_required",
          }),
        });
        return;
      }
      if (this.sessionid) {
        this.inbox_loading = true;
        this.connecting_error = false;
        this.network_error = false;
        this.network_error_message = "";
        this.thread_select = -1;
        this.thread_id = "";
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        const currentRequestId = this.requestId;
        this.axios
          .get(inboxAPI, {
            requestId: currentRequestId,
            params: {
              token: this.token,
              sessionid: this.sessionid,
              refresh: refresh
            },
          })
          .then((response) => {
            // 後続の loadInbox が走っている場合は古いレスポンスを無視
            if (currentRequestId !== this.requestId) return;
            // HTTP 200 でも ExternalApi 包み（403+login_required 等）や status=fail を先に判定
            if (isLoginRequiredError(response.data)) {
              this.inbox_data = [];
              this.threads = [];
              this.login_wait = false;
              this.connecting_error = true;
              this.inbox_loading = false;
              this.$message.closeAll();
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: getLoginRequiredErrorText(response.data),
              });
              return;
            }
            if (isNetworkError(response.data) || (isExternalApiErrorEnvelope(response.data) && response.data.status === "fail")) {
              this.inbox_data = [];
              this.threads = [];
              this.login_wait = false;
              this.network_error = true;
              this.network_error_message = getMessageErrorText(response.data);
              this.inbox_loading = false;
              this.$message.closeAll();
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: this.network_error_message,
              });
              return;
            }
            if (isExternalApiErrorEnvelope(response.data)) {
              // status 未整備のエラー包みも成功扱いしない
              this.inbox_data = [];
              this.threads = [];
              this.login_wait = false;
              this.connecting_error = false;
              this.network_error = true;
              this.network_error_message = getMessageErrorText(response.data);
              this.inbox_loading = false;
              this.$message.closeAll();
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: this.network_error_message,
              });
              return;
            }
            if (response.data.status == "fail") {
              this.inbox_data = [];
              this.threads = [];
              this.login_wait = false;
              if (response.data.message == "login_required" || response.data.message == "challenge_required" || response.data.message == "user_has_logged_out") {
                this.connecting_error = true;
                this.network_error = false;
                this.network_error_message = "";
                this.$message({
                  type: "error",
                  offset: 7,
                  showClose: true,
                  message: getLoginRequiredErrorText(response.data),
                });
              } else {
                // 未分類 fail は再連携案内にせず、既存エラー表示に BE 文言を出す（空白のままにしない）
                this.connecting_error = false;
                this.network_error = true;
                this.network_error_message = getMessageErrorText(response.data);
                this.$message.closeAll();
                this.$message({
                  type: "error",
                  offset: 7,
                  showClose: true,
                  message: this.network_error_message,
                });
              }
              // FIXME 2026-02-05 現在、正常なレスポンスが返ってこず不審なアクセスと検知される可能性があるため、一旦コメントアウト
              // this.getPresence();
            } else if (response.data.status == "login_required") {
              // 旧API互換（分類前レスポンス）
              this.inbox_data = [];
              this.threads = [];
              this.connecting_error = true;
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: getLoginRequiredErrorText(response.data),
              });
            } else {
              this.inbox_data = response.data;
              this.threads = response.data.inbox.threads;
              if (response.data.inbox.oldest_cursor) {
                this.inbox_cursor = response.data.inbox.oldest_cursor;
              }
              this.$store.dispatch("IGAccountUpdate", response.data.inbox.unseen_count);
            }
            this.inbox_loading = false;
            this.$nextTick(() => {
              this.scrollReset();
            });
          })
          .catch((error) => {
            // キャンセル、または後続リクエスト開始済みなら UI を更新しない
            if (currentRequestId !== this.requestId || this.axios.isCancel(error)) return;
            this.inbox_loading = false;
            this.inbox_data = [];
            this.threads = [];
            this.network_error = true;
            this.network_error_message = getMessageErrorText(null);
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: this.network_error_message,
            });
          });
      }
    },
    InboxCursor() {
      this.inbox_cursor_loading = true;
      this.axios
        .get(inboxAPI, {
          params: {
            token: this.token,
            cursor: this.inbox_cursor,
            sessionid: this.sessionid,
          },
        })
        .then((response) => {
          if (response.data.message == "consent_required") {
            this.$confirm(
              "Instagramにて利用規約・データに関するポリシーが更新されています。<br>引き続きご利用いただくにはInstagramのスマホアプリ側にて変更点をご確認の上、同意をいただく必要がございます。<br>(このアラートは同意のご確認が完了するまで継続して表示されます。)",
              "Instagramの利用規約変更",
              {
                dangerouslyUseHTMLString: true,
                cancelButtonText: "閉じる",
                type: "warning",
              }
            ).then(() => {});
          } else {
            var new_threads = this.threads.concat(response.data.inbox.threads);
            this.threads = new_threads;
            if (response.data.inbox.oldest_cursor) {
              this.inbox_cursor = response.data.inbox.oldest_cursor;
            } else {
              this.inbox_cursor = "";
            }
          }
          this.inbox_cursor_loading = false;
        })
        .catch((error) => {
          if (!this.axios.isCancel(error)) {
            this.inbox_cursor_loading = false;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: getMessageErrorText(null),
            });
          }
        });
    },
    openThread(thread_id, thread_index) {
      this.thread_select = thread_index;
      this.thread_id = thread_id;
      this.threads[thread_index].read_state = 0;
      this.ig_id = this.threads[thread_index].users[0].pk;
    },
    getPresence() {
      this.axios
        .get(getPresenceAPI, {
          params: {
            token: this.token,
            sessionid: this.sessionid,
          },
        })
        .then((response) => {
          var presence = response.data.user_presence;
          // presence：IG連携が解除されているアカウントでアクセスした場合は「undefined」
          if (presence) {
            var users = Object.keys(presence);
            for (let z = 0; z < users.length; z++) {
              for (let i = 0; i < this.threads.length; i++) {
                if (Number(users[z]) == this.threads[i].users[0].pk) {
                  this.threads[i].presence = presence[users[z]];
                }
              }
            }
          }
        });
    },
    labelThread(thread_label) {
      if (thread_label == 1) {
        this.$set(this.threads[this.thread_select], "thread_label", 1);
      } else {
        this.$set(this.threads[this.thread_select], "thread_label", 0);
      }
    },
    openList(id) {
      let routeData = this.$router.resolve({
        name: "listDetail",
        params: {
          list_id: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    scrollBottom() {
      var itemArea = document.getElementById("message-itemarea");
      itemArea.scrollTop = 999999;
    },
    toConnectSetting() {
      this.$emit("toConnectSetting")
    },
    handleConnectAccountError(error) {
      if (!error) return;
      this.$message({
        type: "error",
        offset: 7,
        showClose: true,
        message:
          typeof error === "string" && error.trim() !== ""
            ? error
            : getMessageErrorText(null),
      });
    },
    inquiry() {
      this.$intercom.show();
    },
    scrollReset() {
      var itemArea = document.getElementById("thread-top");
      // itemArea：IG連携が解除されているアカウントでアクセスした場合は「null」
      if (itemArea) {
        itemArea.scrollTop = 0;
      }
    },
  },
  watch: {
    sessionid() {
      (this.thread_id = ""), (this.thread_select = -1);
      this.loadInbox();
    },
    // sessionid が空の連携解除アカウント同士の切替でも再描画・トーストできるようにする
    "ig_selected.account_name"() {
      (this.thread_id = ""), (this.thread_select = -1);
      this.loadInbox();
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    lastActivity(val) {
      const now = new Date().getTime();
      const lastUpdate = val / 1000;
      const diffSec = now - lastUpdate;
      if (diffSec / (1000 * 60 * 60 * 24 * 7 * 4) > 1) {
        const diffMonth = Math.floor(diffSec / (1000 * 60 * 60 * 24 * 7 * 4)) + "ヶ月前";
        return diffMonth;
      } else if (diffSec / (1000 * 60 * 60 * 24 * 7) > 1) {
        const diffWeek = Math.floor(diffSec / (1000 * 60 * 60 * 24 * 7)) + "週間前";
        return diffWeek;
      } else if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
    timestampToDate(val) {
      return new Date(val / 1000).toLocaleDateString();
    },
    timestampToTime(val) {
      return new Date(val / 1000).toLocaleString().slice(0, -3);
    },
  },
};
</script>
